import React from "react";
import { useLocation } from "react-router-dom";
import { PageContainer } from "@/components/layout/PageShell";
import { cn } from "@/lib/utils";

/** Wraps report content: no extra padding inside Report Center layout. */
export default function ReportPageWrap({ children, className }) {
  const { pathname } = useLocation();
  const inReportCenter = pathname.startsWith("/reports/");

  if (inReportCenter) {
    return (
      <div className={cn("min-w-0", className)} data-report-root>
        {children}
      </div>
    );
  }

  return (
    <PageContainer className={cn("!max-w-none", className)} data-report-root>
      {children}
    </PageContainer>
  );
}
